import PropTypes from 'prop-types';

export const bucketShape = PropTypes.shape({
  collapsed: PropTypes.bool,
  emptyBuckets: PropTypes.object,
  id: PropTypes.number,
});

export const filterShape = PropTypes.shape({
  month: PropTypes.object,
  year: PropTypes.object,
  audience: PropTypes.object,
  sortType: PropTypes.object,
});

export const tileShape = PropTypes.shape({
  bucketMonth: PropTypes.string,
  fullyAssembled: PropTypes.bool,
  headline: PropTypes.string,
  id: PropTypes.string,
  planDate: PropTypes.string,
  position: PropTypes.number,
});
